import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=0f6de2e2"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"
import style0 from "./Window.vue?vue&type=style&index=0&id=0f6de2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports